<template>
	<p-card class="weighing-form">
		<card-header class="bg-main">
			<div class="tw-p-8 tw-flex tw-justify-between tw-items-center">
				<p class="text-info text-base tw-m-0">Valora este Factor:</p>
				<countdown-timer
					ref="countdownTimer"
					@countdownFinished="onCountdownFinished"
				/>
			</div>
		</card-header>
		<card-sub-header>
			<div class="tw-p-12">
				<weighing-factor-slider
					:factor-name="selectedFactor.name"
					:factor-image="selectedFactor.urlImage"
					:slide-value="weighingAssignation.factorAssign"
					@slideValueChange="onSlideValueChange"
					@sliderInteraction="startCountdown"
					ref="weighingFactorSlider"
				/>
			</div>
		</card-sub-header>
		<card-sub-header class="bg-main">
			<div class="tw-p-8">
				<p class="text-info text-base tw-m-0">Sobre este Factor:</p>
			</div>
		</card-sub-header>
		<weighing-factors-navigation
			:weighing-value="weighingAssignation.comparedFactorAssign"
			:pivot-factor-name="pivotFactor.name"
			:pivot-factor-url-image="pivotFactor.urlImage"
			:has-next="hasNextCompareNavigation"
			:has-prev="hasPrevCompareNavigation"
			@onPrevClick="goPrevFactor"
			@onNextClick="goNextFactor"
		/>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import CardHeader from '@/modules/shared/components/ui/Card/CardHeader';
import CardFooter from '@/modules/shared/components/ui/Card/CardFooter';
import CardSubHeader from '@/modules/shared/components/ui/Card/CardSubHeader';
import Countdown from '@/components/shared/countdown';
import CountdownTimer from '@/modules/shared/components/business/CountdownTimer';
import WeighingFactorSlider from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorSlider';
import WeighingFactorsNavigation from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorsNavigation';
import { find, has, isNil, prop } from 'ramda';

export default {
	name: 'WeighingForm',
	components: {
		WeighingFactorsNavigation,
		WeighingFactorSlider,
		CountdownTimer,
		Countdown,
		CardSubHeader,
		CardFooter,
		CardHeader,
		PCard,
	},
	props: [
		'selectedFactor',
		'selectedFactors',
		'combinations',
		'enabledCountdown',
		'factorsToCompare',
	],
	data() {
		return {
			weighingAssignation: {
				factorAssign: 0,
				comparedFactorAssign: 0,
			},
			pivotFactor: {},
			pivotIndex: 0,
		};
	},
	methods: {
		onCountdownFinished() {
			this.goNextFactor();
		},
		startCountdown() {
			if (this.enabledCountdown) {
				this.$refs.countdownTimer.startCountdown();
			}
		},
		onSlideValueChange(slideValue) {
			this.updateCombination({
				factorAssign: slideValue,
				comparedFactorAssign: 1 - slideValue,
			});
		},
		updateCombination(weighingAssignation) {
			this.weighingAssignation = weighingAssignation;
			const newCombination = {
				[this.selectedFactor.uuid]: weighingAssignation.factorAssign,
				[this.pivotFactor.uuid]: weighingAssignation.comparedFactorAssign,
			};
			this.$store.dispatch('jobEvaluation/updateCombination', newCombination);
		},
		goPrevFactor() {
			this.updatePivotFactor(this.pivotIndex - 1);
		},
		goNextFactor() {
			this.updatePivotFactor(this.pivotIndex + 1);
		},
		updatePivotFactor(index) {
			this.pivotIndex = index;
			this.pivotFactor = prop(index, this.selectedFactor.weighWith);
			this.loadWeighingFromCombination();
			// eslint-disable-next-line no-unused-expressions
			this.$refs.countdownTimer && this.$refs.countdownTimer.resetCountdown();
			this.$emit('comparePivotIndexChange', index);
		},
		loadWeighingFromCombination() {
			this.updateCombination({
				factorAssign:
					prop(this.selectedFactor.uuid, this.comparisonCombination) || 0.25,
				comparedFactorAssign:
					prop(this.pivotFactor.uuid, this.comparisonCombination) || 0.75,
			});
		},
	},
	computed: {
		hasNextCompareNavigation() {
			return !isNil(prop(this.pivotIndex + 1, this.selectedFactor.weighWith));
		},
		hasPrevCompareNavigation() {
			if (this.pivotIndex - 1 < 0) return false;
			return !isNil(prop(this.pivotIndex - 1, this.selectedFactor.weighWith));
		},
		comparisonCombination() {
			return find(
				combination =>
					has(this.pivotFactor.uuid, combination) &&
					has(this.selectedFactor.uuid, combination),
				this.combinations,
			);
		},
	},
	watch: {
		selectedFactor: {
			handler(nextValue, prevValue = {}) {
				if (nextValue.uuid !== prevValue.uuid) {
					this.updatePivotFactor(0);
				}
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.weighing-form {
	margin-right: 30px;
	margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingForm.vue